import Service from "@/helpers/py-service";

const state = {
  loading: false,
  //
  aggregatedData: {},
  //
  meta: {},
  list: [],
  //
};

const mutations = {
  SET_AGG_DATA(state, payload) {
    state.aggregatedData = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
};

const actions = {
  AggregatedData: (store, params) => {
    store.state.loading = true;
    return Service.get("charging-station/session-heatmap", params)
      .then((data) => {
        store.commit("SET_AGG_DATA", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  list: (store, params) => {
    store.state.loading = true;
    return Service.get("charging-station/utilization-breakdown", params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getAggregatedData(state) {
    return state.aggregatedData;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const utilizations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default utilizations;
